import React, { Component } from "react";

interface Props {
  name: string;
}

interface State {}

class Icon extends Component<Props, State> {
  render() {
    const iconName: any = this.props.name ? this.props.name : "";
    let iconSvg: any = "";
    let searchSvg: any;
    if (iconName) {
      searchSvg = icons.filter((icon: any) => icon.name === iconName);
      if (searchSvg[0]) {
        iconSvg = searchSvg[0].svg ? searchSvg[0].svg : "";
      }
    }
    return <span className="icon">{iconSvg}</span>;
  }
}

const icons = [
  {
    name: "search",
    svg: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.9842 15.6825L13.8675 12.575C14.8731 11.2939 15.4187 9.71194 15.4167 8.08334C15.4167 6.63294 14.9866 5.21512 14.1808 4.00915C13.375 2.80319 12.2297 1.86326 10.8897 1.30822C9.54969 0.753177 8.0752 0.607953 6.65267 0.890911C5.23015 1.17387 3.92347 1.8723 2.89789 2.89789C1.8723 3.92347 1.17387 5.23015 0.890911 6.65267C0.607953 8.0752 0.753177 9.54969 1.30822 10.8897C1.86326 12.2297 2.80319 13.375 4.00915 14.1808C5.21512 14.9866 6.63294 15.4167 8.08334 15.4167C9.71194 15.4187 11.2939 14.8731 12.575 13.8675L15.6825 16.9842C15.7677 17.0701 15.8691 17.1383 15.9808 17.1848C16.0925 17.2314 16.2123 17.2553 16.3333 17.2553C16.4543 17.2553 16.5742 17.2314 16.6859 17.1848C16.7976 17.1383 16.899 17.0701 16.9842 16.9842C17.0701 16.899 17.1383 16.7976 17.1848 16.6859C17.2314 16.5742 17.2553 16.4543 17.2553 16.3333C17.2553 16.2123 17.2314 16.0925 17.1848 15.9808C17.1383 15.8691 17.0701 15.7677 16.9842 15.6825ZM2.58334 8.08334C2.58334 6.99554 2.90591 5.93217 3.51025 5.0277C4.1146 4.12323 4.97358 3.41828 5.97858 3.002C6.98357 2.58572 8.08944 2.4768 9.15633 2.68902C10.2232 2.90124 11.2032 3.42506 11.9724 4.19425C12.7416 4.96344 13.2654 5.94344 13.4777 7.01034C13.6899 8.07724 13.581 9.1831 13.1647 10.1881C12.7484 11.1931 12.0434 12.0521 11.139 12.6564C10.2345 13.2608 9.17113 13.5833 8.08334 13.5833C6.62465 13.5833 5.2257 13.0039 4.19425 11.9724C3.1628 10.941 2.58334 9.54203 2.58334 8.08334Z" />
      </svg>
    ),
  },
  {
    name: "arrow",
    svg: (
      <svg
        width="14"
        height="7"
        viewBox="0 0 14 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.58824e-05 5.88002C-0.000423903 5.73593 0.0313676 5.59357 0.0931037 5.46339C0.15484 5.33321 0.244952 5.21852 0.356819 5.12774L6.14199 0.469403C6.31451 0.327549 6.53092 0.25 6.75425 0.25C6.97758 0.25 7.19399 0.327549 7.36651 0.469403L13.1517 5.2917C13.3486 5.45541 13.4724 5.69065 13.4959 5.94568C13.5194 6.2007 13.4407 6.45463 13.277 6.65159C13.1134 6.84855 12.8782 6.97241 12.6232 6.99592C12.3683 7.01943 12.1144 6.94067 11.9175 6.77697L6.74943 2.46583L1.58134 6.6323C1.43982 6.75023 1.26748 6.82515 1.08471 6.84818C0.901951 6.87121 0.716417 6.84139 0.550067 6.76226C0.383716 6.68312 0.243512 6.55797 0.146041 6.40162C0.0485703 6.24527 -0.002086 6.06426 6.58824e-05 5.88002Z" />
      </svg>
    ),
  },
];

export default Icon;
